module.exports = __webpack_public_path__ + "static/SSL25561-241ac4c429c9667f74fcb2ed66b6b6ad.jpg";